import * as actionType from "../constants";
import * as commonData from "../Common";

export const renamesingleboard = (inputs) => async (dispatch) => {
  dispatch({ type: actionType.BOARD_RENAMING });
  const apiurl = commonData.commonData().apiUrl;
  try {
    const response = await fetch(`${apiurl}board/update`, {
      method: "post",
      body: JSON.stringify(inputs),
    });

    const newre = await response.json();
    if (newre.code === 200) {
      const { data } = newre;
      const renameattr = {
        attr_key: data.attribute_set_key,
        attr_name: data.attribute_set_name,
      };
      dispatch({
        type: actionType.BOARD_RENAMED,
        payload: {
          renameattr,
          message: newre.message,
          status: newre.status,
          code: newre.code,
        },
      });
    } else {
      dispatch({
        type: actionType.RENAME_BOARD_ERROR,
        payload: {
          message: newre.message,
          status: newre.status,
          code: newre.code,
        },
      });
    }

    setTimeout(() => {
      dispatch({ type: actionType.BOARD_MESSAGE_DEACTIVATE });
    }, 4000);
  } catch (error) {
    console.log(error);
  }
};
